import React from 'react';
import { styled } from '@compiled/react';
import { Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const optionWrapperBaseStyles = xcss({
	minHeight: '25px',
	position: 'relative',
	paddingBlock: 'space.075',
	paddingInline: 'space.150',
	cursor: 'pointer',
});

const isOptionBeingEditedStyles = xcss({
	padding: 'space.0',
});

const isEditingStyles = xcss({
	cursor: 'inherit',
});

export const OptionWrapper = ({
	isOptionBeingEdited,
	isEditing,
	testId,
	children,
}: {
	isOptionBeingEdited: boolean;
	isEditing: boolean;
	testId: string;
	children: React.ReactNode;
}) => (
	<Flex
		alignItems="center"
		justifyContent="space-between"
		xcss={[
			optionWrapperBaseStyles,
			isOptionBeingEdited && isOptionBeingEditedStyles,
			isEditing && isEditingStyles,
		]}
		testId={testId}
	>
		{children}
	</Flex>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CategoryWrapper = styled.div({
	width: 'calc(100% - 50px)',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const OptionIconsWrapper = styled.div<{ isHoveringOption: boolean }>({
	position: 'absolute',
	right: token('space.0', '0px'),
	padding: `0 ${token('space.075', '6px')}`,
	height: '100%',
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	button: {
		background: 'transparent',
	},
});
